"use client";

import { useQuery } from "convex/react";
import { api } from "@convex/_generated/api";
import { BlockListView } from "./block-list-view";
import { BlockFormSheet } from "./block-form-sheet";
import { Plus } from "lucide-react";

export function BlockList() {
  const result = useQuery(api.blocks.listBlocksWithShifts, { limit: 100 });
  const blocks = result?.blocks;

  // Special case: empty state with add button
  if (result !== undefined && (!blocks || blocks.length === 0)) {
    return (
      <div className="pb-24">
        <div className="text-center py-12">
          <p className="text-muted-foreground mb-4">
            No blocks yet. Add your first work block to start tracking!
          </p>
          <BlockFormSheet
            mode="create"
            trigger={
              <button className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-all duration-300 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground shadow hover:bg-primary/90 hover:shadow-lg hover:scale-105 active:scale-95 h-9 px-4 py-2">
                <Plus className="w-4 h-4 mr-2 transition-transform duration-300 hover:rotate-90" />
                Add Block
              </button>
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="pb-24">
      <BlockListView
        blocks={blocks}
        showFilters={true}
        emptyMessage="No blocks yet. Add your first work block to start tracking!"
      />
    </div>
  );
}
